import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pseudo-link',
  templateUrl: './pseudo-link.component.html',
  styleUrls: ['./pseudo-link.component.scss']
})
export class PseudoLinkComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
